import React, { useMemo } from 'react';
import loadable from '@loadable/component';
import { Spin } from 'antd';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CM_BASE_ROUTE } from '../pages/constants/cmConstants';
import { hasResource } from '../util';
import { getSelectedResources } from '../util/resourceManager';
import NotFoundPage from '../pages/common/NotFoundPage';
import SafeRedirect from './SafeRedirect';

const { cmResources } = getSelectedResources();

const StyledSpin = styled(Spin)`
  width: 100%;
  margin: 200px 0;
`;

const CMApp = loadable(
  () =>
    import(
      /* webpackChunkName: "cm" */
      '../pages/cm/CMApp'
    ),
  {
    fallback: <StyledSpin delay={500} />
  }
);

const CMRoutes = ({ authentication }) => {
  const hasAccess = useMemo(
    () =>
      hasResource(
        authentication?.data,
        cmResources.APP_7_RESOURCE_UI_CM_GENERIC
      ),
    [authentication]
  );

  return hasAccess ? (
    <>
      <Switch>
        <Route
          exact
          path="/app"
          render={({ history }) => (
            <SafeRedirect to={CM_BASE_ROUTE} history={history} />
          )}
        />
        <Route path={CM_BASE_ROUTE} component={CMApp} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </>
  ) : null;
};

CMRoutes.propTypes = {
  authentication: PropTypes.object
};

export default CMRoutes;
